import { Component, inject, input } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { ParagraphComponent } from '../text/p/p.component';
import { EventManager } from '@app/shared/utils/event-manager';
import { Modal, ModalType, NonPersistedModalName } from '@app/shared/models/modal.model';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'slotcom-shop-recurring-bag',
  templateUrl: './shop-recurring-bag.component.html',
  styleUrls: ['./shop-recurring-bag.component.scss'],
  standalone: true,
  imports: [SharedModule, ParagraphComponent],
})
export class ShopRecurringBagComponent {
  private eventManager = inject(EventManager);
  private matDialog = inject(MatDialog);

  totalAchievements = input<number>();

  openProgressLine(): void {
    if (this.matDialog.getDialogById(NonPersistedModalName.UserTrophiesModalComponent)) {
      this.eventManager.closeModal(new Modal(NonPersistedModalName.UserTrophiesModalComponent, ModalType.View));
    }

    this.eventManager.openModal(new Modal(NonPersistedModalName.ProgressLineCasinoComponent, ModalType.View, {}));
  }
}
